import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import AdContainer from '../../../../components/ads';
import UserReviews from '../user-reviews';
import ReviewSummary from '../../../../components/review-summary';
import ExpertTestSummary from '../../../expert/product-test/components/test-summary';
import ExpertToplistSummary from '../../../expert/toplists/components/toplist-summary';
import ExpertListOfToplists from '../../../expert/toplists/components/list-of-toplists';
import {
  AdvizedTest,
  AdvizedToplist,
  Product,
  UserReviewSummary,
} from '../../../../types';
import * as S from '../../styles';

const ProductTabReviews: React.FC<IProductTabReviewsProps> = props => {
  const { product, userReviews, userReviewsSummary } = props;

  const { t, market } = useContext(AppContext);

  const expertTest = product?.expert?.selected?.find(
    item => item && item.__typename === 'AdvizedTest'
  ) as AdvizedTest;

  const expertToplist = product?.expert?.selected?.find(
    item => item && item.__typename === 'AdvizedToplist'
  ) as AdvizedToplist;

  const expertToplists = product?.expert?.toplist
    ?.map(toplist =>
      toplist?.toplists
        ?.map(
          list =>
            list && {
              ...list,
              products: list?.products.filter(p => p.id === product.id),
            }
        )
        .filter(list => list)
    )
    .filter(toplist => toplist) as AdvizedToplist[][];

  return (
    <>
      <AdContainer
        placement="panorama_extra"
        format="panorama_1_wde"
        min={861}
        max={10000}
        scalable
        scaleBase=".pj-ui-panel--row"
        spacing={{
          top: '10px',
          bottom: '10px',
        }}
      />

      <AdContainer
        placement="dubbelpanorama1"
        format="panorama_1"
        min={0}
        max={860}
        spacing={{
          top: '10px',
          bottom: '10px',
        }}
      />

      <S.ReviewsWrapper data-test="ReviewsTabContent">
        <S.Reviews>
          <UserReviews
            belongsTo={{
              id: product.id,
              name: product.name,
              type: 'product',
            }}
            myReview={userReviews && userReviews.myReview}
            nodes={userReviews && userReviews.nodes}
            pageInfo={userReviews && userReviews.pageInfo}
            showAds={false}
          />
        </S.Reviews>

        <S.ReviewsSidebar>
          <ReviewSummary
            rating={userReviewsSummary.rating}
            count={userReviewsSummary.count}
            countTotal={userReviewsSummary.countTotal}
            distribution={userReviewsSummary.distribution}
            myReview={userReviews?.myReview}
            belongsTo={{
              id: product.id,
              name: product.name,
              type: 'product',
            }}
            showPrompt
          />

          {market.experts.enabled && expertTest ? (
            <S.ExpertContent>
              <S.Title>{t('expert', 'expert.brand-name')}</S.Title>

              <ExpertTestSummary productId={product.id} review={expertTest} />
            </S.ExpertContent>
          ) : null}

          {market.experts.enabled && !expertTest && expertToplist ? (
            <S.ExpertContent>
              <S.Title>{t('expert', 'expert.brand-name')}</S.Title>

              <ExpertToplistSummary product={product} toplist={expertToplist} />
            </S.ExpertContent>
          ) : null}

          {market.experts.enabled &&
          expertToplists &&
          expertToplists.length > 0 ? (
            <S.ExpertContent>
              <S.Subtitle>
                {t('expert', 'toplist.product-in-lists', {
                  n: expertToplists.length,
                })}
              </S.Subtitle>
              <ExpertListOfToplists toplists={expertToplists} />
            </S.ExpertContent>
          ) : null}
        </S.ReviewsSidebar>
      </S.ReviewsWrapper>
    </>
  );
};

interface IProductTabReviewsProps {
  product: Product;
  userReviews: any;
  userReviewsSummary: UserReviewSummary;
}

export default ProductTabReviews;
